import localforage from 'localforage'

let localforageStoreCountry = localforage.createInstance({
  name: 'qm-survey-webapp',
  storeName: 'country'
})

const initialState = {
  all: [],
  country: {
    id: null,
    text: null
  }
}

let state = initialState

const getters = {
  allCountries: state => state.all
}

const actions = {
  importCountries ({ commit }, countries) {
    return new Promise((resolve, reject) => {
      commit('clearCountryState')
      countries.forEach((country, index) => {
        country.id = String(country.id).trim() // attention: country id's are delivered as strings
        country.text = country.text.trim()
        localforageStoreCountry.setItem(country.id, country.text)
      })
      commit('setCountriesToState', countries)
      resolve()
    })
  },
  loadAllCountries ({ commit }) {
    return new Promise((resolve, reject) => {
      var countries = []
      commit('clearCountryState')
      localforageStoreCountry.getItems().then((results) => {
        Object.keys(results).forEach((key) => {
          var value = results[key]
          countries.push({id: key, text: value})
        })
        countries.sort((a, b) => a.text.localeCompare(b.text))
        commit('setCountriesToState', countries)
        resolve()
      })
    })
  },
  clearCountriesStorage ({ commit }) {
    return new Promise((resolve, reject) => {
      localforageStoreCountry.clear().then(() => {
        commit('clearCountryState')
        resolve()
      })
    })
  }
}

// mutations
const mutations = {
  setCountriesToState (state, countries) {
    state.all = countries
  },
  clearCountryState (state) {
    state = initialState
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/country.js